import { useEffect, useReducer } from 'react';
import { order } from '@spa/shared/utils/order';
import { useKeyHandler, getItems } from '@spa/shared/hooks/keyHandler';
import { KEY_CODES, SPECIAL_ACTIONS } from '@spa/shared/constants/navigationKeys';

const defaultValue = 0;

const initalState = { selected: defaultValue, item: null, items: [], blured: false };

const initialReducer = (state, { type, item, items, selected }) => {
  switch (type) {
    case KEY_CODES.TAB:
    case KEY_CODES.ESC:
      return {
        ...state,
        blured: true,
        selected: defaultValue
      };
    case KEY_CODES.ENTER:
      return {
        ...state,
        item: item
      };
    case KEY_CODES.ARROW_UP:
      return {
        ...state,
        selected: order(items.length, state.selected, -1),
        items: items
      };
    case KEY_CODES.ARROW_DOWN:
      return {
        ...state,
        selected: order(items.length, state.selected, 1),
        items: items
      };
    case SPECIAL_ACTIONS.RESTORE:
      return initalState;
    case SPECIAL_ACTIONS.GOTO:
      return {
        ...state,
        selected: selected
      };
    default:
      return state;
  }
};

export const useKeyNavigation = (ref, reducer = useReducer(initialReducer, initalState)) => {
  const { isFocused, blur, state, focus, dispatch } = useKeyHandler(ref, reducer);

  useEffect(() => {
    if (!state.item) {
      return;
    }

    state.item.click();
  }, [state.item]);

  useEffect(() => {
    const { items, selected } = state;
    if (!items[selected]) {
      return;
    }

    items[selected].focus();
  }, [state.selected]);

  useEffect(() => {
    if (!state.blured) {
      return;
    }

    blur();
    dispatch({ type: SPECIAL_ACTIONS.RESTORE });
  }, [state.blured]);

  useEffect(() => {
    if (!isFocused) {
      return;
    }

    const items = getItems(ref.current);

    if (items.length < 1) {
      return;
    }

    const listeners = items.map((_, index) => () => dispatch({ type: SPECIAL_ACTIONS.GOTO, selected: index }));
    items.map((item, index) => item.addEventListener('focus', listeners[index]));

    return () => items.map((item, index) => item.removeEventListener('focus', listeners[index]));
  });

  return { isFocused, blur, focus, state };
};
